import { Mark, mergeAttributes } from '@tiptap/core';


export const BookSubscript = Mark.create({
  name: 'subscript',
  excludes: 'superscript',
  parseHTML: () => [{ tag: 'sub' }],
  renderHTML: ({ HTMLAttributes }) => [
    'sub',
    mergeAttributes(HTMLAttributes),
    0,
  ],
});

export const BookSuperscript = Mark.create({
  name: 'superscript',
  excludes: 'subscript',
  parseHTML: () => [{ tag: 'sup' }],
  renderHTML: ({ HTMLAttributes }) => [
    'sup',
    mergeAttributes(HTMLAttributes),
    0,
  ],
});

export const toggleBookScript = (editor, type) => {
  if (!editor || !['subscript', 'superscript'].includes(type)) return false;
  const opposite = type === 'subscript' ? 'superscript' : 'subscript';
  return editor
    .chain()
    .focus()
    .unsetMark(opposite)
    .toggleMark(type)
    .run();
};
